export function addToArray(arr: string[], value: string): string[] {
  return [...arr, value];
}

export function removeFromArray(arr: string[], value: string): string[] {
  return arr.filter((v) => v !== value);
}

export function removeAtIndex(arr: string[], index: number): string[] {
  return arr.filter((_, i) => i !== index);
}
